<template>
    <nav>
        <v-app-bar flat dense app>
            <v-app-bar-nav-icon
                large
                @click.stop="drawer = !drawer"
                v-if="$route.name !== 'registration'"
            ></v-app-bar-nav-icon>
            <v-toolbar-title class="text-uppercase grey--text"
                ><span class="font-weight-light"
                    >Tark<span class="font-weight-medium">Pay</span> {{ "Backoffice" | t }}</span
                >
            </v-toolbar-title>
            <v-spacer />
            <v-select
                v-if="user.id && user.user_companies && user.user_companies.length > 1"
                class="company-select mr-2"
                v-model="selectedCompany"
                :items="user.user_companies"
                item-text="name"
                item-value="company_id"
                @change="onChangeCompany"
                return-object
                hide-details
                dense
                solo
            />
            <v-btn
                :disabled="!is_logged_in"
                v-if="user.first_name && $route.name === 'companies-list'"
                class="grey--text mr-2"
                @click="openNewCompanyDrawer"
            >
                <v-icon>add</v-icon>
            </v-btn>
            <v-btn
                :disabled="!is_logged_in"
                v-if="user.first_name && $route.name === 'users-list'"
                class="grey--text mr-2"
                @click="openNewUserDrawer"
            >
                <v-icon>add</v-icon>
            </v-btn>
            <v-btn :disabled="!is_logged_in" v-if="user.id" class="grey--text" @click="LogOut">
                <span>{{ "Sign out" | t }}</span>
                <v-icon right>exit_to_app</v-icon>
            </v-btn>
        </v-app-bar>
        <v-navigation-drawer app v-model="drawer" v-if="user.id" color="grey" class="lighten-3">
            <v-list dense>
                <v-list-item>
                    <v-list-item-avatar style="background-color: white">
                        <v-icon>person</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-title
                        ><strong>{{ user.first_name ? user.first_name : "Unknown" }}</strong></v-list-item-title
                    >
                </v-list-item>
                <v-divider class="ma-2" />
                <v-list-item
                    link
                    v-for="item in drawerItems"
                    :key="'drawer_item_' + item.title"
                    :to="{ path: item.route }"
                    dark
                    active-class="active-drawer-item"
                    :id="item.id"
                >
                    <v-list-item-icon>
                        <v-icon class="black--text">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="black--text">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </nav>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Store from "../store";
import router from "@/router";

export default {
    name: "navbar",
    data() {
        return {
            drawer: true,
            drawerItems: [
                { title: this.t("How to use"), icon: "help_outline", route: "/admin/landing", id: "landingPage" },
                {
                    title: this.t("E-shops & solutions"),
                    icon: "mdi-cart-plus",
                    route: "/admin/solutions",
                    id: "solutionsPage"
                },
                {
                    title: this.t("Create payment"),
                    icon: "payment",
                    route: "/admin/payment/create",
                    id: "createPaymentPage"
                },
                {
                    title: this.t("Payment history"),
                    icon: "history",
                    route: "/admin/payments-history",
                    id: "paymentHistoryPage"
                },
                {
                    title: this.t("Bulk payment history"),
                    icon: "history",
                    route: "/admin/bulk-payments-history",
                    id: "bulkPaymentHistoryPage"
                },
                {
                    title: this.t("Upload CSV"),
                    icon: "upload_file",
                    route: "/admin/upload-csv",
                    id: "uploadCsv"
                },
                { title: this.t("Settings"), icon: "settings", route: "/admin/settings", id: "settingsPage" }
            ],
            selectedCompany: { id: null, name: "-", company_id: null }
        };
    },
    computed: {
        ...mapState(["is_logged_in", "user"])
    },
    async mounted() {
        if (!this.user.id && this.$route.meta.requires_auth) await Store.dispatch("getLoggedUserData");
        if (this.user.role === "admin" || this.user.company_role === "owner") {
            await this.drawerItems.unshift({
                title: this.t("Dashboard"),
                icon: "info_outline",
                route: "/admin/dashboard",
                id: "dashboard"
            });
            await this.drawerItems.push({
                title: this.t("Users"),
                icon: "person",
                route: "/admin/users",
                id: "usersPage"
            });
        }
        await this.drawerItems.push({
            title: this.t("Consent"),
            icon: "mdi-currency-eur",
            route: "/admin/consent",
            id: "consent"
        });
        if (this.user.role === "admin") {
            await this.drawerItems.push(
                {
                    title: this.t("Companies"),
                    icon: "business_center",
                    route: "/admin/companies",
                    id: "companiesPage"
                },
                {
                    title: this.t("Onboarding"),
                    icon: "mdi-file",
                    route: "/admin/onboarding",
                    id: "adminOnboarding"
                },
                {
                    title: this.t("General settings"),
                    icon: "settings_system_daydream",
                    route: "/admin/general-settings",
                    id: "generalSettingsPage"
                }
            );
        }
        this.selectedCompany = this.user.user_companies.find(uc => uc.company_id === this.user.active_company);
    },
    methods: {
        ...mapActions(["changeCompany"]),
        ...mapMutations(["setIsLoggedIn"]),
        LogOut() {
            router.push("/app/logout");
        },
        openNewCompanyDrawer() {
            this.$router.push({ name: "company-edit", params: { companyId: "new" } });
        },
        openNewUserDrawer() {
            this.$router.push({ name: "user-edit", params: { userId: "new" } });
        },
        onChangeCompany(e) {
            this.changeCompany(e);
        }
    }
};
</script>

<style scoped>
.company-select {
    max-width: 300px;
    min-width: 50px;
}
</style>
